'use client'

import {
  Box,
  Flex,
  HStack,
  Input,
  InputGroup,
  IconButton,
} from '@chakra-ui/react'
import { ColorModeButton } from '@/shared/ui/color-mode'
import { glassBlur, glassPanel } from '@/shared/lib/chakra/glass'
import { Search, Bell } from 'lucide-react'
import { LocaleSwitcher } from './LocaleSwitcher'
import { UserRolesPopover } from './UserRolesPopover'

export function Header() {
  return (
    /* Sticky rail: masks content scrolling under the floating header card.
       Light mode uses the flat page colour; dark mode blurs instead, so the
       page wash keeps showing through the gaps around the card. */
    <Box
      position="sticky"
      top={0}
      zIndex={10}
      bg={{ base: 'bg', _dark: 'transparent' }}
      backdropFilter={{ _dark: glassBlur }}
      px={6}
      pt={3}
      pb={2}
      flexShrink={0}
    >
      <Box as="header" {...glassPanel} borderRadius="16px" px={5} h="56px">
        <Flex h="full" align="center" gap={4}>
          {/* Search */}
          <InputGroup flex={1} maxW="380px" startElement={<Search size={15} />}>
            <Input
              placeholder="Search..."
              size="sm"
              bg="bg.subtle"
              border="none"
              borderRadius="full"
              _focus={{ boxShadow: 'none', border: 'none' }}
            />
          </InputGroup>

          <Flex flex={1} />

          {/* Right actions */}
          <HStack gap={1}>
            <LocaleSwitcher />
            <ColorModeButton color="fg.muted" />
            <IconButton
              variant="ghost"
              size="sm"
              aria-label="Notifications"
              color="fg.muted"
            >
              <Bell size={18} />
            </IconButton>
            <Box pl={2} ml={1} borderLeftWidth="1px" borderColor="border">
              <UserRolesPopover />
            </Box>
          </HStack>
        </Flex>
      </Box>
    </Box>
  )
}
